import { useEffect, useState } from "react";
import { Hub } from "aws-amplify";
import { HubPayload } from "@aws-amplify/core";
import { 
    EVENT_NAME,
    MSG,
    SIGNED_IN_FLAG,
    DATASTORE_CHANNEL,
    READY_EVENT
} from "./constants/SessionStorageKeys";

export const useLoginEventBroadcast = () => {
    const [isReady, setIsReady] = useState(false);
    const [shouldReload, setShouldReload] = useState(false);

    // setup listener for datastore events to manage ready and reload state
    useEffect(() => {
        const listener = (capsule: { payload: HubPayload }) => {
            const { event } = capsule.payload;
            console.log('Datastore event received:', event);

            if (event === READY_EVENT) {
                console.log('Datastore is ready');
                setIsReady(true);
            }
        };
        try {
            Hub.listen(DATASTORE_CHANNEL, listener);
            return () => Hub.remove(DATASTORE_CHANNEL, listener);
        } catch (error) {
            console.error('Failed to setup Datastore listener:', error);
        }
    }, []);

    // this effect actually reloads the page
    useEffect(() => {
        if (isReady && shouldReload) {
            console.log('Reloading page after Datastore is ready');
            window.location.reload();
            setShouldReload(false);
        }
    }, [isReady, shouldReload]);

    // Manage broadcasting reload event to other tabs
    useEffect(() => {
        let channel: BroadcastChannel;
        try {
            channel = new BroadcastChannel(EVENT_NAME);

            channel.addEventListener("message", (event) => {
                if (event.data === MSG) {
                    const shouldReload = sessionStorage.getItem(SIGNED_IN_FLAG) !== "true";
                    if (shouldReload) {
                        sessionStorage.setItem(SIGNED_IN_FLAG, "true");
                        setShouldReload(true);
                    }
                }
            });

            //Run second reload for current tab
            const localFlag = sessionStorage.getItem(SIGNED_IN_FLAG) === "true";
            if (localFlag) {
                sessionStorage.removeItem(SIGNED_IN_FLAG);
            }
        } catch (error) {
            console.error('Failed to setup BroadcastChannel:', error);
        }
        return () => {
            channel?.close();
        };
    }, []);
    return { isReady, shouldReload };
};